import { z } from 'zod';

import { CONTRACT_CONDITION_NOT_IN_FORCE_REASONS } from '../constants';
import {
  zodContractConditionSchema,
  zodContractPriceScaleStepSchema,
  zodPositiveDecimalSchema,
} from '../validations';

/**
 * Validation schemas for the contract item net price API call.
 */

// Query parameter validations
export const zodContractItemNetPriceQueryParamsSchema = z.object({
  // Quantity in single item units; defaults to the item's ordered quantity.
  quantity: zodPositiveDecimalSchema.optional(),
  // Day the validity windows are judged against; defaults to today in Berlin.
  referenceDate: z.iso.date().optional(),
});

// One condition applied to the price, with the price before and after it
const zodContractItemNetPriceStepSchema = z.object({
  condition: zodContractConditionSchema,
  priceAfter: z.string(),
  priceBefore: z.string(),
});

// A condition outside its validity window or quantity range; it does not
// change the price
const zodContractItemNetPriceNotInForceSchema = z.object({
  condition: zodContractConditionSchema,
  reasons: z.array(z.enum(CONTRACT_CONDITION_NOT_IN_FORCE_REASONS)),
});

// Response schema
export const zodContractItemNetPriceResponseSchema = z.object({
  amount: z.string().nullish(),
  basePrice: z.string(),
  currency: z.string(),
  flatConditions: z.array(zodContractConditionSchema),
  listPrice: z.string(),
  netPrice: z.string(),
  notInForce: z.array(zodContractItemNetPriceNotInForceSchema),
  // Amounts per unit in a unit other than the item's own; listed, not added.
  otherUnitConditions: z.array(zodContractConditionSchema),
  priceStep: zodContractPriceScaleStepSchema.nullish(),
  priceUnit: z.number().int(),
  quantity: z.string().nullish(),
  referenceDate: z.iso.date(),
  steps: z.array(zodContractItemNetPriceStepSchema),
});
